<template>
  <div class="login-container">
    <div class="card">
      <p class="fs-20 color-dark fw-600 mg-b-60">BYD Deductible Reimbursement Program</p>
      <div class="form-item">
        <span>Username</span>
        <v-input
          v-model="username"
          @keyEnter="requestLogin"/>
      </div>
      <div class="form-item">
        <span>Password</span>
        <v-input
          v-model="password"
          type="password"
          @keyEnter="requestLogin" />
      </div>
      <v-button
        type="success"
        @click="requestLogin">Login</v-button>
    </div>
  </div>
</template>
<script>
import {login, secondLogin} from '@/api'
import {mapActions} from 'vuex'

export default {
  name: 'login',
  data() {
    return {
      // 2991349941@qq.com
      username: '',
      password: ''
      // 12345678
    }
  },
  mounted(){
    const token = localStorage.getItem('token')
  },
  methods: {
    ...mapActions('verify',['setIsReset','setIsVerify']),
    requestLogin() {
      this.network().login()
    },
    network() {
      return {
        login: async () => {
          const {data} = await login({
            username: this.username,
            password: this.password
          })
          localStorage.setItem('token', data.access_token)
          localStorage.setItem('auth', JSON.stringify(data))
          const {fullPath = ''} = this.$route.query
          this.$router.replace('/')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: #fff;
  .fs-20{
    font-size: 20px;
  }
  .mg-b-60{
    margin-bottom: 60px;
  }
  .card {
    padding: 100px 0;
    width: 500px;
    text-align: center;
    box-shadow:none;
    .form-item {
      margin: 0 auto;
      width: 500px;
      & > span {
        text-align: left;
      }
    }
    .el-button{
      width: 100%;
      margin-top: 20px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      //display: flex;
      //align-items: center;
      letter-spacing: -0.15px;
      color: #FFFFFF;
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-sizing: border-box;
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      border-radius: 6px;
      &--success:hover {
        background: #2EA44F;
        opacity: 0.8;
        border-color: rgba(27, 31, 35, 0.15);
      }
    }
  }
}
</style>
